import * as httpleaseAsap from 'httplease-asap';
import { decodeAsapPrivateKeyDataUri } from './decode';
export function generateAsapHeader({ issuer, audience, keyId, privateKey, subject }) {
    if (privateKey.includes('data:application/pkcs8')) {
        const { keyId: uriKeyId, privateKey: uriPrivateKey } = decodeAsapPrivateKeyDataUri(privateKey);
        keyId = uriKeyId;
        privateKey = uriPrivateKey;
    }
    const jwtConfig = {
        privateKey,
        issuer,
        keyId,
        audience,
        subject
    };
    const authHeaderGenerator = httpleaseAsap.createAuthHeaderGenerator(jwtConfig);
    return authHeaderGenerator();
}
//# sourceMappingURL=asap-header-generator.js.map